module.exports = __webpack_public_path__ + "img/Sina.234b16b.png";